// extracted by mini-css-extract-plugin
export var accountAttentionIcon = "Jgm9G";
export var addAccountIconBrand = "QiYXS";
export var addAccountIconDisabled = "rhKDD";
export var addAccountNodeState = "ujAnO";
export var compact = "zbE2K";
export var criticalStateColor = "ErAGq";
export var full = "TMc_w";
export var hide = "cfoHY";
export var medium = "F__Ik";
export var nearingStateColor = "m6Dx3";
export var nonPaddedContainer = "ZOvjw";
export var paddedContainer = "fDFs6";
export var tooltip = "LmjYz";